export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmation required"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authorization must be confirmed with a one-time key"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authorization must be confirmed with a magic word"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Registration must be confirmed by the code from the SMS message"])}
}